<template>
  <div class="top-left">
    <a href="#" @click="toggleTranslate">
      <span class="material-icons-outlined"> translate </span>
    </a>
    <transition name="translate-dropdown">
      <div v-show="showTranslateMenu" class="translate-menu">
        <div class="modal-header">
          <div class="modal-title-container">
            <div class="modal-divider"></div>
          </div>
        </div>
        <div class="item-header">
          <h3>{{ $t("Custom.language") }}</h3>
        </div>
        <div class="translate-content">
          <div class="flags-languages">
            <div
              class="flags-languages-item"
              @click="changeLanguage('en', 'en-US')"
            >
              <img
                src="@/assets/img/flags/united-kingdom.png"
                alt="United Kingdom Flag"
              />
              <div class="language">English</div>
            </div>
            <div
              class="flags-languages-item"
              @click="changeLanguage('ar', 'ar-SY')"
            >
              <img src="@/assets/img/flags/syria.png" alt="Syria Flag" />
              <div class="language">العربية</div>
            </div>
            <div
              class="flags-languages-item"
              @click="changeLanguage('tr', 'tr-TR')"
            >
              <img src="@/assets/img/flags/turkey.png" alt="Turkish Flag" />
              <div class="language">Türkçe</div>
            </div>
            <div
              class="flags-languages-item"
              @click="changeLanguage('de', 'de-DE')"
            >
              <img
                src="@/assets/img/flags/germany.png"
                alt="United Kingdom Flag"
              />
              <div class="language">German</div>
            </div>
            <div
              class="flags-languages-item"
              @click="changeLanguage('fr', 'fr-FR')"
            >
              <img
                src="@/assets/img/flags/france.png"
                alt="United Kingdom Flag"
              />
              <div class="language">French</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "PropertiesComponent",
  data() {
    return {
      showTranslateMenu: false,
    };
  },
  methods: {
    toggleTranslate(event) {
      this.showTranslateMenu = !this.showTranslateMenu;
      if (this.showTranslateMenu) {
        document.body.style.overflow = "hidden"; 
      } else {
        document.body.style.overflow = ""; 
      }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showTranslateMenu = false;
        document.body.style.overflow = ""; 
      }
    },
    changeLanguage(lang, localeTime) {
      location.reload();
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      localStorage.setItem("localeTime", localeTime);
      this.showTranslateMenu = false;
      document.body.style.overflow = "";
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.item-header {
  padding: 15px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background: white;
  border-radius: 10px 10px 0 0;
  z-index: 1;
  display: none;
}

.item-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.translate-menu {
  position: absolute;
  width: 155px;

  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
  margin-top: 38px;
  left: 0;
}

.translate-content {
  padding: 5px;
  font-weight: 500;
  font-size: 0.9rem;
  max-height: 200px;
  overflow-y: auto; 
}

.flags-languages {
  display: flex;
  flex-direction: column;
}

.flags-languages-item {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  margin: 3px;
  cursor: pointer;
}

.flags-languages-item:hover {
  background-color: #f4f5fa;
}

.flags-languages-item img {
  width: 30px; /* Bayrak resimleri için sabit genişlik */
  height: auto;
  margin-right: 10px; /* Bayrak ile dil arasındaki boşluk */
}

.language {
  font-size: 0.9rem;
}

.top-left {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-right: 2px;
  z-index: 1000;
}

.top-left a {
  text-decoration: none;
  display: flex;
  align-items: center;
  /* 
  color: #000;
  background-color: #f4f5fa;
  */
  padding: 9px;
  margin-right: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--logo-color) 0%, #d18a0f 100%);
}

.top-left a:hover {
  background-color: #e1e4f5;
}

.top-left a .material-icons-outlined {
  color: var(--text-white);
  font-size: 16px;
}

.translate-dropdown-enter-active,
.translate-dropdown-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.translate-dropdown-enter,
.translate-dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.modal-header {
  display: none;
}

.modal-title-container {
  display: flex;
  justify-content: center;
}

.modal-divider {
  width: 70px;
  height: 4px;
  background: #ccc;
  border-radius: 2px;
  margin-top: 8px;
  cursor: pointer;
  display: none; /* Initially hidden */
}

@media screen and (max-width: 768px) {
  .translate-menu {
    overflow-y: auto;
    position: fixed;
    bottom: 0;
    top: 60%;
    margin-top: 0;
    left: 0;
    width: 100%;
    max-height: 40vh;
    border-radius: 10px 10px 0 0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    animation: slideUp-0296431e 0.3s ease-in-out;
  }

  .translate-content {
    overflow-y: hidden;
  }

  .item-header {
    display: block;
  }

  .translate-content {
    max-height: 100%;
  }

  .flags-languages-item {
    padding: 12px 25px;
  }

  .flags-languages-item img {
    width: 40px;
    margin-right: 15px;
  }

  .language {
    font-weight: bold;
    font-size: 0.9rem;
  }
  .modal-header {
    display: flex;
    flex-direction: column;
    padding: 4px 10px 0px 9px;
  }

  .modal-divider {
    display: block;
  }

  .translate-dropdown-enter-active,
  .translate-dropdown-leave-active {
    transition: transform 0.3s ease, opacity 0.3s ease;
  }
  .translate-dropdown-enter,
  .translate-dropdown-leave-to {
    transform: translateY(100%);
    opacity: 0;
  }

  .top-left a .material-icons-outlined {
    font-size: 10px;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
}
</style>
